module.exports = { "default": require("core-js/library/fn/json/stringify"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-runtime/core-js/json/stringify.js
// module id = ./node_modules/babel-runtime/core-js/json/stringify.js
// module chunks = main